import Vue from 'vue'
import Router, { RawLocation, Route } from 'vue-router'
import Home from '@/components/Home.vue'
import Panier from '@/components/Panier.vue'
import ProductId from '@/components/ProductId.vue'
import { IAccessMeta } from '@/services/access'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { access: { allowAnonymous: true } as IAccessMeta, title: 'Accueil' }
      // meta: { access: { allowAnonymous: true } as IAccessMeta, title: 'Accueil', layout: { noNav: true } }
    },
    {
      path: '/panier',
      name: 'panier',
      component: Panier,
      meta: { access: { allowAnonymous: true } as IAccessMeta }
    },
    {
      path: '/produit/:name',
      name: 'productId',
      component: ProductId,
      meta: { access: { allowAnonymous: true } as IAccessMeta }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
